/* Copyright (c) 2017 Backpack Health LLC */

import _ from 'lodash';
// import FormData1 from 'form-data';

import { authorizedApiRequest } from './apiRequest';
// import ProfileModel from 'models/ProfileModel';
import ApiErrorModel from 'models/ApiErrorModel';

const api = {
  get: function getProfile(profileId) {
    return authorizedApiRequest('get', `profiles/${profileId}`);
  },
  update: function updateProfile(profileId) {
    return authorizedApiRequest('put', `profiles/${profileId}`);
  },
  updateAvatar: function updateProfileAvatar(profileId) {
    return authorizedApiRequest('put', `profiles/${profileId}/avatar`);
  },
  delAvatar: function updateProfileAvatar(profileId) {
    return authorizedApiRequest('delete', `profiles/${profileId}/avatar`);
  },
  getAll: function getAllProfiles() {
    return authorizedApiRequest('get', 'profiles');
  },
  createDependent: function createDependentProfile() {
    return authorizedApiRequest('post', 'profiles');
  },
  deleteDependent: function deleteDependentProfile(profileId) {
    return authorizedApiRequest('delete', `profiles/${profileId}`);
  },
  getNextProfileColorTheme: function getNextProfileColorTheme() {
    return authorizedApiRequest('get', 'profiles/colorTheme');
  },
  getOwnersForProfile: function getOwnersForProfile(profileId) {
    return authorizedApiRequest('get', `profiles/${profileId}/owners`);
  },
  removeOwnerFromProfile: function removeOwnerFromProfile(profileId, ownerProfileId) {
    return authorizedApiRequest('delete', `profiles/${profileId}/owners/${ownerProfileId}`);
  },
};

const profileApi = {
  get(profileId) {
    return api.get(profileId)()
    .then(res => res.data.data);
  },

  update(profileData) {
    let cleanedProfileData = _.assign({}, profileData);
    if (!cleanedProfileData.other_gender) {
      cleanedProfileData = _.omit(cleanedProfileData, 'other_gender');
    }

    return api.update(cleanedProfileData.id)(cleanedProfileData)
    .then(res => null);
  },

  updateAvatar(profileId, photoData, progressCallback) {
    const form = new window.FormData();
    form.append('avatar', photoData, { type: photoData.type });

    return api.updateAvatar(profileId)(form, {
      onUploadProgress: progressCallback,
    }).then(() => null);
  },

  delAvatar(profileId) {
    return api.delAvatar(profileId)()
    .then(res => null);
  },

  getAll() {
    return api.getAll()()
    .then(res => res.data.data);
  },

  createDependentProfile(profileData) {
    return api.createDependent()(profileData)
    .then(res => res.data.data);
  },

  deleteDependentProfile(profileId) {
    return api.deleteDependent(profileId)()
    .then(res => null);
  },

  getNextProfileColorTheme() {
    return api.getNextProfileColorTheme()()
    .then(res => res.data.data);
  },

  getOwnersForProfile(profileId) {
    return api.getOwnersForProfile(profileId)()
    .then(res => res.data.data);
  },

  removeOwnerFromProfile(profileId, ownerProfileId) {
    return api.removeOwnerFromProfile(profileId, ownerProfileId)()
    .then(res => null);
  },

};

export default profileApi;
